import type { AuditActivity } from '../types/auditLogs';

export const mockAuditActivities: AuditActivity[] = [
  {
    id: '1',
    type: 'CREATE',
    title: 'New user group created',
    description: 'Marketing Team group created by Admin User',
    user: 'Admin User',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    details: {
      groupName: 'Marketing Team',
      permissions: 'Read, Write'
    }
  },
  {
    id: '2',
    type: 'UPDATE',
    title: 'Permission modified',
    description: 'Travel Agency group permissions updated by Brij',
    user: 'Brij',
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000), // 5 hours ago
    details: {
      groupName: 'Travel Agency',
      changedPermissions: 'Admin access granted'
    }
  },
  {
    id: '3',
    type: 'LOGIN',
    title: 'User login',
    description: 'Brij logged into the system',
    user: 'Brij',
    timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000), // 6 hours ago (Today, 9:30 AM)
    details: {
      ipAddress: '192.168.1.100',
      userAgent: 'Chrome/91.0'
    }
  },
  {
    id: '4',
    type: 'DELETE',
    title: 'User group deleted',
    description: 'Temporary Staff group deleted by Admin User',
    user: 'Admin User',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000), // Yesterday, 4:15 PM
    details: {
      groupName: 'Temporary Staff',
      reason: 'Project completed'
    }
  },
  {
    id: '5',
    type: 'UPDATE',
    title: 'Group membership changed',
    description: '2 users added to Frontliner group by Admin User',
    user: 'Admin User',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000 - 5 * 60 * 60 * 1000), // Yesterday, 2:30 PM
    details: {
      groupName: 'Frontliner',
      usersAdded: 2,
      action: 'Added users'
    }
  },
  {
    id: '6',
    type: 'CREATE',
    title: 'New user account created',
    description: 'New user account created for John Doe by Admin User',
    user: 'Admin User',
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    details: {
      newUser: 'John Doe',
      role: 'Frontliner',
      department: 'Customer Service'
    }
  },
  {
    id: '7',
    type: 'LOGIN',
    title: 'User login',
    description: 'Admin User logged into the system',
    user: 'Admin User',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), // 3 days ago
    details: {
      ipAddress: '192.168.1.50',
      userAgent: 'Firefox/89.0'
    }
  },
  {
    id: '8',
    type: 'UPDATE',
    title: 'System configuration updated',
    description: 'Travel insurance settings modified by System Admin',
    user: 'System Admin',
    timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000), // 4 days ago
    details: {
      module: 'Travel Insurance',
      setting: 'Maximum coverage amount',
      oldValue: '100000',
      newValue: '150000'
    }
  }
];

export const getAuditActivities = (): Promise<AuditActivity[]> => {
  // Simulate API delay
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockAuditActivities);
    }, 500);
  });
};

export const exportAuditLogs = (format: 'csv' | 'pdf'): Promise<Blob> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (format === 'csv') {
        const csvContent = [
          'ID,Type,Title,Description,User,Timestamp',
          ...mockAuditActivities.map(activity => 
            `${activity.id},${activity.type},"${activity.title}","${activity.description}",${activity.user},${activity.timestamp.toISOString()}`
          )
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv' });
        resolve(blob);
      } else {
        // Mock PDF export
        const pdfContent = `Audit Logs Report\n\n${mockAuditActivities.map(activity => 
          `${activity.type}: ${activity.title}\n${activity.description}\nUser: ${activity.user}\nTime: ${activity.timestamp.toLocaleString()}\n\n`
        ).join('')}`;
        
        const blob = new Blob([pdfContent], { type: 'application/pdf' });
        resolve(blob);
      }
    }, 1000);
  });
};